import PubSub from "underpub-js";

var NavigationPopupSubItem = function (options) {

  this.options = {
    $el: false,
    baseClass: 'atom-NavigationPopupSubItem',
  };

  $.extend(true, this.options, options);

};

NavigationPopupSubItem.prototype.init = function () {

  var self = this;

};

export default NavigationPopupSubItem;